import React from 'react';
import { Field, TextArea } from 'ui';
import RequiredStar from '~/components/ListFlow/RequiredStar';
import {
  changeDescription,
  changeTitle,
  getListFlowDescription,
  getListFlowGeneratedTitle,
  getListFlowTitle,
  isListFlowUsingGeneratedTitle,
} from '~/store/listFlow/slices/info';
import { getListFlowTitleError } from '~/store/listFlow/ui';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ListFlowTitleAndDescription: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const titleError = useAppSelector(getListFlowTitleError);
  const title = useAppSelector(getListFlowTitle);
  const generatedTitle = useAppSelector(getListFlowGeneratedTitle);
  const usingGeneratedTitle = useAppSelector(isListFlowUsingGeneratedTitle);
  const description = useAppSelector(getListFlowDescription);

  const currentTitle = usingGeneratedTitle ? generatedTitle : title || '';

  const handleTitleChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    dispatch(changeTitle(e.target.value));
  };

  const handleDescriptionChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = e => {
    dispatch(changeDescription(e.target.value));
  };

  return (
    <div>
      <Field
        name="title"
        error={titleError}
        label={
          <span>
            Title <RequiredStar />
          </span>
        }
        value={currentTitle}
        onChange={handleTitleChange}
      />

      <Field name="description" label="Description">
        <TextArea
          value={description || ''}
          onChange={handleDescriptionChange}
          placeholder="Description (e.g. Blue Nike Vapor cleats Size 10. Worn for 5 games. Very comfortable and strong ankle support, but I grew out of them. A few scuffs from normal use. Retails for $99, going to buy another pair."
          style={{
            height: 120,
          }}
        />
      </Field>
    </div>
  );
};

export default ListFlowTitleAndDescription;
